import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-percentage-display',
    templateUrl: './percentage-display.component.html',
    styleUrls: ['./percentage-display.component.scss'],
    standalone: false
})
export class PercentageDisplayComponent {
  @Input() percentage: number = 0;
} 
